// global elements and pages

const initPageTransition = () => {
	document.querySelectorAll('a[href]').forEach((item) => {
		// if href points to anchor, or points to anchor that exists on page
		if (
			item.href.startsWith('#') ||
			(item.href.split('#')[1] &&
				item.href.split('#')[0] == location.href.split('#')[0])
		) {
			item.setAttribute('data-page-transition', 'scroll');
		} else if (
			(item.href.includes(siteUrl) || item.href.startsWith('/')) &&
			item.target != '_blank' &&
			!item.href.includes('mailto:')
		) {
			item.setAttribute('data-page-transition', 'internal');
		} else {
			item.rel = 'noopener';
			item.target = item.target || '_blank';
		}
	});

	on('body', 'click', '[data-page-transition]', (e) => {
		let target = e.target.hasAttribute('data-page-transition')
			? e.target
			: e.target.closest('[data-page-transition]');

		target.blur();

		if (
			target.dataset.pageTransition == 'internal' &&
			!root.classList.contains('key-is-down')
		) {
			e.preventDefault();
			root.classList.remove(
				'menu-is-active',
				'mobile-menu-is-active',
				'minicart-is-active',
				'overlay-is-active'
			);

			root.classList.add('is_leaving');

			setTimeout(() => {
				location.href = target.href;
			}, 200);
		}
	});

	window.addEventListener('keydown', () => {
		root.classList.add('key-is-down');
	});

	window.addEventListener('keyup', () => {
		root.classList.remove('key-is-down');
	});
};

const initPageAnimation = () => {
	document.querySelectorAll('.js-animate').forEach((item) => {
		let observer = new IntersectionObserver(
			(el) => {
				if (
					el[0].isIntersecting === true &&
					!el[0].target.classList.contains('is-animated')
				) {
					el[0].target.classList.add('is-animated');
				}
			},
			{
				root: null,
				threshold: [0.4], // 0 = page start; 1 = page bottom, items only revealed when in full view
			}
		);

		observer.observe(item);
	});
};

const initProduct = () => {
	const findVariant = (product) => {
		// get all selected options
		const selectedOptions = Array.from(
			product.querySelectorAll(`[data-variant-option].is-selected`)
		);

		// generate title in shopify format
		const variantTitle = selectedOptions
			.map((option) => {
				return option.dataset.variantValue;
			})
			.join(' / ');

		const matchingVariant = product.querySelector(
			`input[data-variant-title="${variantTitle}"]`
		);
		matchingVariant.click();

		return matchingVariant;
	};

	const resetOptionStates = (product, optionIndex) => {
		const options = product.querySelectorAll(
			`[data-variant-option="${optionIndex}"]`
		);
		options.forEach((option) => {
			option.classList.remove('is-selected');
		});
	};

	const setPrice = (product, variant) => {
		const discount =
			variant.dataset.recurring == 'true'
				? parseInt(variant.dataset.subscriptionSavings) / 100
				: 0;
		const price = Math.round(parseInt(variant.dataset.price));
		const priceDiscounted = Math.round(price * (1 - discount));

		const priceLabels = product.querySelectorAll('.js-price-label');
		priceLabels.forEach((label) => {
			label.innerText = '$' + price;
			discount
				? label.classList.remove('is-active')
				: label.classList.add('is-active');
		});

		const priceDiscountLabels = product.querySelectorAll(
			'.js-price-label-discount'
		);
		priceDiscountLabels.forEach((label) => {
			if (discount) label.innerText = '$' + priceDiscounted;
			discount
				? label.classList.add('is-active')
				: label.classList.remove('is-active');
		});
	};

	const setSubscription = (product, isRecurring) => {
		const variants = product.querySelectorAll('input[data-recurring]');
		variants.forEach((variant) => {
			variant.setAttribute('data-recurring', isRecurring);
		});

		const subscriptionToggleOn = product.querySelector('.js-subscription-on');
		if (subscriptionToggleOn) {
			if (isRecurring == true) subscriptionToggleOn.checked = true;
			const subscriptionOn = subscriptionToggleOn
				? subscriptionToggleOn.checked
				: false;
			const selectedPlan = product.querySelector(
				'.combobox-option.is-option-current'
			);
			const subscriptionId =
				selectedPlan && subscriptionOn
					? selectedPlan.dataset.value || selectedPlan.value
					: '';

			variants.forEach((variant) => {
				variant.setAttribute('data-selling-plan', subscriptionId);
			});
		}
	};

	// subscription update: on checkbox toggling
	on('body', 'click', '.js-subscription-toggle', (e) => {
		const product = e.target.closest('.js-product');
		const toggleOn = product.querySelector('.js-subscription-on');
		const isRecurring = toggleOn.checked;
		setSubscription(product, isRecurring);
		const matchingVariant = findVariant(product);
		setPrice(product, matchingVariant);
	});

	// subscription update: on virtual select frequency change
	on('body', 'click', '.js-subscription-options [data-value]', (e) => {
		const product = e.target.closest('.js-product');
		const isRecurring = true;
		setSubscription(product, isRecurring);
		const matchingVariant = findVariant(product);
		setPrice(product, matchingVariant);
	});

	// subscription update: on native select frequency change
	on('body', 'change', '.js-subscription-options select', (e) => {
		const product = e.target.closest('.js-product');
		const isRecurring = true;
		setSubscription(product, isRecurring);
		const matchingVariant = findVariant(product);
		setPrice(product, matchingVariant);
	});

	on('body', 'click', '[data-variant-option]', (e) => {
		const product = e.target.closest('.js-product');
		const option = e.target.closest('[data-variant-option]');
		const optionIndex = option.dataset.variantOption;

		// only one option value per option should be selected at a time
		resetOptionStates(product, optionIndex);
		option.classList.add('is-selected');

		// generate variant title and find matching form input to select
		const matchingVariant = findVariant(product);
		setPrice(product, matchingVariant);
	});

	// init
	const products = document.querySelectorAll('.js-product');

	products.forEach((product) => {
		const variantOptions1 = product.querySelectorAll(
			'[data-variant-option="1"]'
		);
		const variantOptions2 = product.querySelectorAll(
			'[data-variant-option="2"]'
		);
		const variantOptions3 = product.querySelectorAll(
			'[data-variant-option="3"]'
		);

		// select defaults
		if (variantOptions1[0]) variantOptions1[0].classList.add('is-selected');
		if (variantOptions2[0]) variantOptions2[0].classList.add('is-selected');
		if (variantOptions3[0]) variantOptions3[0].classList.add('is-selected');

		const matchingVariant = findVariant(product);
		setPrice(product, matchingVariant);
	});

	// read more button

	on('body', 'click', '.js-read-more', (e) => {
		const product = e.target.closest('.js-product');
		const readMoreContent = product.querySelector('.js-read-more-content');
		readMoreContent.classList.add('is-active');
	});
};

const initItemQuantity = () => {
	const updateItemQuantity = (controls, direction = 0) => {
		const quantityMin = controls.dataset.quantityMin || 1;
		const quantityMax = controls.dataset.quantityMax || 99;
		const quantityLabel = controls.querySelector('.js-quantity-label');
		const quantityInput = controls.querySelector('.js-quantity-input');
		const quantityPlural = controls.querySelector('.js-quantity-plural');
		const quantityCurrent = parseInt(quantityLabel.innerText);
		const quantityNew = Math.min(
			Math.max(quantityCurrent + direction, quantityMin),
			quantityMax
		);
		if (quantityInput) quantityInput.value = quantityNew;
		if (quantityLabel) quantityLabel.innerText = quantityNew;
		if (quantityPlural) {
			quantityNew > 1
				? (quantityPlural.innerText = 's')
				: (quantityPlural.innerText = '');
		}
	};

	on('body', 'click', '.js-quantity-decrease, .js-quantity-increase', (e) => {
		const direction = e.target.closest('.js-quantity-increase') ? 1 : -1;
		const controls = e.target.closest('.js-quantity-controls');
		updateItemQuantity(controls, direction);
	});
};

const initCart = () => {
	// cart visibility
	const minicartClose = () => {
		root.classList.remove('minicart-is-active');
		history.pushState(null, null, ' ');
		scrollEnable();
	};

	const minicartOpen = () => {
		root.classList.add('minicart-is-active');
		history.pushState(null, null, '#cart');
		scrollDisable();
	};

	on('body', 'click', '.js-minicart-open', (e) => {
		root.classList.contains('minicart-is-active')
			? minicartClose()
			: minicartOpen();
	});

	on('body', 'click', '.js-minicart-close', (e) => {
		minicartClose();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key == 'Escape') {
			minicartClose();
		}
	});

	// trigger cart if url contains the hash
	if (location.hash == '#cart') {
		minicartOpen();
	}

	// updates both cart price and item count
	this.reloadCartData = () => {
		fetch('/cart.js')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				const cartTotal = Math.round(parseFloat(data.total_price / 100));
				document.querySelectorAll('.js-cart-total-price').forEach((item) => {
					item.innerText = `$${cartTotal}`;
				});

				let cartHasSubscription = false;
				for(const item of data.items) {
					if(item.selling_plan_allocation) {
						cartHasSubscription = true;
					}
				}

				updateFreeShipping(cartTotal, cartHasSubscription);

				document.querySelectorAll('.js-cart-total-items').forEach((item) => {
					item.innerText = data.item_count;
				});

				data.item_count > 0
					? root.classList.add('cart-has-items')
					: root.classList.remove('cart-has-items');

				const wholesaleLinks = document.querySelectorAll(
					'.js-wholesale-checkout-link'
				);

				if (wholesaleLinks.length > 0) {
					const remainingWholesaleItems = minWholesaleItems - data.item_count;

					if (remainingWholesaleItems > 0) {
						const message = `${remainingWholesaleItems} more to check out – $${cartTotal}`;
						wholesaleLinks.forEach((link) => {
							link.setAttribute('disabled', 'true');
							link.querySelector('span')
								? (link.querySelector('span').innerText = message)
								: (link.innerText = message);
						});
					} else {
						const message = `Check out – $${cartTotal}`;
						wholesaleLinks.forEach((link) => {
							link.removeAttribute('disabled');
							link.querySelector('span')
								? (link.querySelector('span').innerText = message)
								: (link.innerText = message);
						});
					}
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// updates .cart-items HTML
	this.reloadCartItems = () => {
		reloadCartData();

		fetch('/cart')
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				var parser = new DOMParser();
				var dataHtml = parser.parseFromString(data, 'text/html');

				// insert the new cart items
				document.querySelectorAll('.cart-items-wrapper').forEach((item) => {
					item.innerHTML = dataHtml.querySelector(
						'.cart-items-wrapper'
					).innerHTML;
				});
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to add items
	this.addItem = (
		variantId,
		quantity,
		updateCartTotal = true,
		updateCartItems = true,
		minicartOpenDelay = 400,
		sellingPlan = ''
	) => {
		const loadingButtons = document.querySelectorAll('.js-loader');
		loadingButtons.forEach((loader) => {
			loader.classList.add('is-loading');
		});

		fetch('/cart/add.js', {
			method: 'POST',
			body: JSON.stringify({
				id: variantId,
				quantity: quantity,
				selling_plan: sellingPlan,
			}),
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then((response) => {
				response.json();
			})
			.then((data) => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay != 'false'
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';

				setTimeout(() => {
					loadingButtons.forEach((loader) => {
						loader.classList.remove('is-loading');
					});
				}, 400);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	// use this function to change item quantity
	this.changeItemQuantity = (
		line,
		quantity,
		updateCartTotal = true,
		updateCartItems = false,
		minicartOpenDelay = 400
	) => {
		fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				line: line,
				quantity: quantity,
			}),
		})
			.then((response) => {
				response.json();
			})
			.then(() => {
				updateCartTotal ? reloadCartData() : '';
				updateCartItems ? reloadCartItems() : '';
				minicartOpenDelay != false
					? setTimeout(() => {
							minicartOpen();
					  }, minicartOpenDelay)
					: '';
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};

	reloadCartData();

	on('body', 'click', '.js-item-change-quantity', (e) => {
		const item = e.target.closest('.cart-item');
		const quantity = parseInt(
			item.querySelector('.js-quantity-label').innerText
		);

		if (item) {
			changeItemQuantity(
				item.dataset.itemLine,
				quantity,
				(updateCartTotal = true),
				(updateCartItems = true),
				(minicartOpenDelay = false)
			);
		}
	});

	on('body', 'click', '.js-item-remove', (e) => {
		let item = e.target.closest('.cart-item');

		if (item) {
			item.remove();
			changeItemQuantity(item.dataset.itemLine, 0, true, true, false);
		}
	});

	on('body', 'click', '[data-cart-add-id]', (e) => {
		let target = e.target.closest('[data-cart-add-id]');

		addItem(target.dataset.cartAddId, target.dataset.cartAddQuantity || 1);
	});

	on('body', 'submit', 'form[action="/cart/add"]', (e) => {
		e.preventDefault();
		const form = e.target.closest('form');
		const variant = form.querySelector('[name="id"]:checked');
		const variantId = variant.value;
		const quantity = form.querySelector('.js-quantity-label')
			? parseInt(form.querySelector('.js-quantity-label').innerText)
			: 1;
		const sellingPlan =
			variant.dataset.recurring == 'true' ? variant.dataset.sellingPlan : '';

		addItem(
			variantId,
			quantity,
			(updateCartTotal = true),
			(updateCartItems = true),
			(minicartOpenDelay = form.dataset.cartTrigger || 400),
			sellingPlan
		);
	});

	const freeShippingGoal = 85;
	const freeShipping = document.querySelector('.free-shipping');
	const freeShippingRemainderLabel = document.querySelector(
		'.free-shipping-remainder'
	);
	const freeShippingProgressBar = document.querySelector(
		'.free-shipping-progress'
	);

	const updateFreeShipping = (cartTotal, cartHasSubscription) => {
		let freeShippingProgress = 0;
		if(cartHasSubscription) {
			freeShippingProgress = 100;
		} else {
			const freeShippingRemainer = Math.round(
				parseInt(freeShippingGoal - cartTotal)
			);
			freeShippingProgress = Math.min((cartTotal / freeShippingGoal) * 100, 100);
			freeShippingRemainderLabel.innerText = '$' + freeShippingRemainer;
		}
		
		freeShippingProgressBar.style.width = freeShippingProgress + '%';

		if(cartHasSubscription || cartTotal >= freeShippingGoal) {
			freeShipping.classList.add('free_shipping_success');
		} else {
			freeShipping.classList.remove('free_shipping_success');
		}
		
	};

	let cartNote = document.querySelector('#cart-note');
	let cartNoteLabel = document.querySelector('#cart-note-label');
	let cartNoteField = document.querySelector('#cart-note-field');

	const initCartNote = () => {
		cartNoteLabel.addEventListener('click', () => {
			cartNote.classList.toggle('active');

			// adjust label text
			if (!cartNote.classList.contains('active')) {
				// clear value
				cartNoteField.value = '';
				cartNoteLabel.innerText = 'Add gift message';
			} else {
				cartNoteLabel.innerText = 'Remove gift message';
			}
		});
	};

	initCartNote();
};

const initAccount = () => {
	// account gate
	const gateWrapper = document.querySelector('.account-gate-wrapper');
	const gateContent = document.querySelector('.account-gate');
	const resetPasswordTrigger = document.querySelector(
		'.reset-password-trigger'
	);
	const resetPasswordCancel = document.querySelector('.reset-password-cancel');

	if (gateWrapper) {
		resetPasswordTrigger.addEventListener('click', (event) => {
			event.preventDefault();

			// update URL with hash
			history.pushState(null, null, '#recover');

			// assign active state
			root.classList.add('reset-password-active');

			// update wrapper height to fit account reset form
			gateWrapper.style.height =
				document.querySelector('.account-reset').offsetHeight;

			// focus on email field
			document.querySelector('#account-recover-email').focus();
		});

		if (resetPasswordCancel) {
			resetPasswordCancel.addEventListener('click', (event) => {
				event.preventDefault();

				// remove has from URL
				history.pushState(null, null, ' ');

				// remove active state from root
				root.classList.remove('reset-password-active');

				// update wrapper height to fit account reset form
				gateWrapper.style.height = gateContent.offsetHeight;
			});
		}

		// trigger password recovery form if url contains the hash
		if (location.hash == '#recover') {
			resetPasswordTrigger.click();
		}

		// set initial height
		gateWrapper.style.height = gateContent.offsetHeight;
	}
};

const initCollection = () => {
	const wholesaleLoginTrigger = document.querySelector(
		'.js-wholesale-login-trigger'
	);
	const wholesaleLogin = document.querySelector('.js-wholesale-login');

	// login within wholesale gate
	if (wholesaleLoginTrigger && wholesaleLogin) {
		wholesaleLoginTrigger.addEventListener('click', () => {
			wholesaleLogin.classList.add('is-active');
		});
	}

	// if we are looking at wholesale items, disable the rose minicart (which overlaps)
	const minicartMonogram = document.querySelector('.minicart-monogram');
	const wholesaleItemsActive = document.querySelector('.js-is-wholesale');
	const cartWholeSaleItems = document.querySelectorAll(
		'[data-wholesale="true"]'
	);
	const cartHasWholeSaleItems = cartWholeSaleItems.length > 0;
	if (wholesaleItemsActive) {
		minicartMonogram.remove();
		//append js-wholesale-checkout-link to the main checkout link for disabled state
		const checkoutLink = document.getElementById('cart-actions-checkout');
		checkoutLink.classList.add('js-wholesale-checkout-link');

		const freeShipping = document.querySelector('.free-shipping');
		freeShipping.remove();
	} else if (cartHasWholeSaleItems) {
		fetch('/cart/clear.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest',
			},
			credentials: 'same-origin',
		})
			.then((response) => {
				response.json();
				reloadCartData();
				reloadCartItems();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
};

const initComboBox = () => {
	'use strict';

	// Save a list of named combobox actions, for future readability
	const SelectActions = {
		Close: 0,
		CloseSelect: 1,
		First: 2,
		Last: 3,
		Next: 4,
		Open: 5,
		PageDown: 6,
		PageUp: 7,
		Previous: 8,
		Select: 9,
		Type: 10,
	};

	/*
	 * Helper functions
	 */

	// filter an array of options against an input string
	// returns an array of options that begin with the filter string, case-independent
	function filterOptions(options = [], filter, exclude = []) {
		return options.filter((option) => {
			const matches =
				option.innerText.toLowerCase().indexOf(filter.toLowerCase()) === 0;
			return matches && exclude.indexOf(option) < 0;
		});
	}

	// map a key press to an action
	function getActionFromKey(event, menuOpen) {
		const { key, altKey, ctrlKey, metaKey } = event;
		const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ']; // all keys that will do the default open action
		// handle opening when closed
		if (!menuOpen && openKeys.includes(key)) {
			return SelectActions.Open;
		}

		// home and end move the selected option when open or closed
		if (key === 'Home') {
			return SelectActions.First;
		}
		if (key === 'End') {
			return SelectActions.Last;
		}

		// handle typing characters when open or closed
		if (
			key === 'Backspace' ||
			key === 'Clear' ||
			(key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)
		) {
			return SelectActions.Type;
		}

		// handle keys when open
		if (menuOpen) {
			if (key === 'ArrowUp' && altKey) {
				return SelectActions.CloseSelect;
			} else if (key === 'ArrowDown' && !altKey) {
				return SelectActions.Next;
			} else if (key === 'ArrowUp') {
				return SelectActions.Previous;
			} else if (key === 'PageUp') {
				return SelectActions.PageUp;
			} else if (key === 'PageDown') {
				return SelectActions.PageDown;
			} else if (key === 'Escape') {
				return SelectActions.Close;
			} else if (key === 'Enter' || key === ' ') {
				return SelectActions.CloseSelect;
			}
		}
	}

	// return the index of an option from an array of options, based on a search string
	// if the filter is multiple iterations of the same letter (e.g "aaa"), then cycle through first-letter matches
	function getIndexByLetter(options, filter, startIndex = 0) {
		const orderedOptions = [
			...options.slice(startIndex),
			...options.slice(0, startIndex),
		];
		const firstMatch = filterOptions(orderedOptions, filter)[0];
		const allSameLetter = (array) =>
			array.every((letter) => letter === array[0]);

		// first check if there is an exact match for the typed string
		if (firstMatch) {
			return options.indexOf(firstMatch);
		}

		// if the same letter is being repeated, cycle through first-letter matches
		else if (allSameLetter(filter.split(''))) {
			const matches = filterOptions(orderedOptions, filter[0]);
			return options.indexOf(matches[0]);
		}

		// if no matches, return -1
		else {
			return -1;
		}
	}

	// get an updated option index after performing an action
	function getUpdatedIndex(currentIndex, maxIndex, action) {
		const pageSize = 10; // used for pageup/pagedown

		switch (action) {
			case SelectActions.First:
				return 0;
			case SelectActions.Last:
				return maxIndex;
			case SelectActions.Previous:
				return Math.max(0, currentIndex - 1);
			case SelectActions.Next:
				return Math.min(maxIndex, currentIndex + 1);
			case SelectActions.PageUp:
				return Math.max(0, currentIndex - pageSize);
			case SelectActions.PageDown:
				return Math.min(maxIndex, currentIndex + pageSize);
			default:
				return currentIndex;
		}
	}

	// check if element is visible in browser view port
	function isElementInView(element) {
		var bounding = element.getBoundingClientRect();

		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <=
				(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	// check if an element is currently scrollable
	function isScrollable(element) {
		return element && element.clientHeight < element.scrollHeight;
	}

	// check if on mobile or tablet device
	function isMobileOrTablet() {
		const userAgent = navigator.userAgent.toLowerCase();

		return (
			/iPhone|Android/i.test(navigator.userAgent) ||
			/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
				userAgent
			)
		);
	}

	// ensure a given child element is within the parent's visible scroll area
	// if the child is not visible, scroll the parent
	function maintainScrollVisibility(activeElement, scrollParent) {
		const { offsetHeight, offsetTop } = activeElement;
		const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;

		const isAbove = offsetTop < scrollTop;
		const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;

		if (isAbove) {
			scrollParent.scrollTo(0, offsetTop);
		} else if (isBelow) {
			scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
		}
	}

	/*
	 * Select Component
	 * Accepts a combobox element and an array of string options
	 */
	const Select = function (el, options = {}) {
		// element refs
		this.el = el;
		this.selector = this.el.querySelector('select');
		this.comboBox = el.querySelector('.combobox');
		this.comboEl = document.createElement('div');
		this.listboxEl = document.createElement('div');

		this.comboEl.setAttribute('aria-controls', `${this.el.id}-listbox`);
		this.comboEl.setAttribute('aria-expanded', false);
		this.comboEl.setAttribute('aria-haspopup', 'listbox');
		this.comboEl.setAttribute('aria-labelledby', `${this.el.id}-label`);
		this.comboEl.setAttribute('role', 'combobox');
		this.comboEl.setAttribute('tabindex', 0);
		this.comboEl.id = `${this.el.id}-input`;
		this.comboEl.classList.add('combobox-input');
		this.comboBox.prepend(this.comboEl);

		this.listboxEl.setAttribute('aria-labelledby', `${this.el.id}-label`);
		this.listboxEl.setAttribute('role', 'listbox');
		this.listboxEl.setAttribute('tabindex', '-1');
		this.listboxEl.id = `${this.el.id}-listbox`;
		this.listboxEl.classList.add('combobox-menu');
		this.comboBox.prepend(this.listboxEl);

		// data
		this.idBase = this.comboEl.id || 'combo';
		this.options = options;

		// state
		this.activeIndex = 0;
		this.open = false;
		this.searchString = '';
		this.searchTimeout = null;

		// init
		if (el && this.comboEl && this.listboxEl) {
			this.init();

			const label = this.el.querySelector('label');
			// assign ID to <label> and <select>
			label.setAttribute('for', `${this.el.id}-select`);
			label.id = `${this.el.id}-label`;
			this.selector.id = `${this.el.id}-select`;

			// match <select> actions to combobox
			this.selector.addEventListener('change', (event) => {
				// event.stopPropagation();
				this.onOptionClick(this.selector.selectedIndex);
			});

			if (isMobileOrTablet()) {
				this.listboxEl.setAttribute('aria-hidden', true);
			} else {
				this.el.classList.add('is-select-hidden');
			}
		}
	};

	Select.prototype.init = function () {
		// select first option by default
		this.comboEl.innerHTML = this.options[0].innerText;

		// add event listeners
		this.comboEl.addEventListener('blur', this.onComboBlur.bind(this));
		this.comboEl.addEventListener('click', this.onComboClick.bind(this));
		this.comboEl.addEventListener('keydown', this.onComboKeyDown.bind(this));

		// create options
		this.options.map((option, index) => {
			const optionText = option.innerText;
			const optionValue = option.value;
			const optionData = option.dataset;
			const optionClasses =
				option.classList != '' ? option.className.trim().split(' ') : false; // sanitize extra spaces
			const optionEl = this.createOption(
				optionText,
				optionValue,
				optionData,
				optionClasses,
				index
			);
			this.listboxEl.appendChild(optionEl);
		});
	};

	Select.prototype.createOption = function (
		optionText,
		optionValue,
		optionData,
		optionClasses,
		index
	) {
		const optionEl = document.createElement('div');
		optionEl.setAttribute('role', 'option');
		optionEl.id = `${this.idBase}-${index}`;
		optionEl.className =
			index === 0 ? 'combobox-option is-option-current' : 'combobox-option';
		optionEl.setAttribute('aria-selected', `${index === 0}`);
		optionEl.setAttribute('data-value', optionValue);

		optionEl.innerText = optionText;

		// add each data attribute to new el
		if (optionClasses) {
			optionClasses.forEach((className) => {
				optionEl.classList.add(className.replace(' ', '')); // remove extra spaces
			});
		}

		// add each data attribute to new el
		if (optionData) {
			for (let prop in optionData) {
				optionEl.setAttribute('data-' + toKebabCase(prop), optionData[prop]);
			}
		}

		optionEl.addEventListener('click', (event) => {
			// event.stopPropagation();
			this.onOptionClick(index);
		});
		optionEl.addEventListener('mousedown', this.onOptionMouseDown.bind(this));

		return optionEl;
	};

	Select.prototype.getSearchString = function (char) {
		// reset typing timeout and start new timeout
		// this allows us to make multiple-letter matches, like a native select
		if (typeof this.searchTimeout === 'number') {
			window.clearTimeout(this.searchTimeout);
		}

		this.searchTimeout = window.setTimeout(() => {
			this.searchString = '';
		}, 500);

		// add most recent letter to saved search string
		this.searchString += char;
		return this.searchString;
	};

	Select.prototype.onComboBlur = function () {
		// do not do blur action if ignoreBlur flag has been set
		if (this.ignoreBlur) {
			this.ignoreBlur = false;
			return;
		}

		// select current option and close
		if (this.open) {
			this.selectOption(this.activeIndex);
			this.updateMenuState(false, false);
		}
	};

	Select.prototype.onComboClick = function () {
		this.updateMenuState(!this.open, false);
	};

	Select.prototype.onComboKeyDown = function (event) {
		const { key } = event;
		const max = this.options.length - 1;

		const action = getActionFromKey(event, this.open);

		switch (action) {
			case SelectActions.Last:
			case SelectActions.First:
				this.updateMenuState(true);
			// intentional fallthrough

			case SelectActions.Next:
			case SelectActions.Previous:
			case SelectActions.PageUp:
			case SelectActions.PageDown:
				event.preventDefault();
				return this.onOptionChange(
					getUpdatedIndex(this.activeIndex, max, action)
				);
			case SelectActions.CloseSelect:
				event.preventDefault();
				this.onOptionClick(this.activeIndex);
			// this.selectOption(this.activeIndex);
			// intentional fallthrough

			case SelectActions.Close:
				event.preventDefault();
				return this.updateMenuState(false);
			case SelectActions.Type:
				return this.onComboType(key);
			case SelectActions.Open:
				event.preventDefault();
				return this.updateMenuState(true);
		}
	};

	Select.prototype.onComboType = function (letter) {
		// open the listbox if it is closed
		this.updateMenuState(true);

		// find the index of the first matching option
		const searchString = this.getSearchString(letter);
		const searchIndex = getIndexByLetter(
			this.options,
			searchString,
			this.activeIndex + 1
		);

		// if a match was found, go to it
		if (searchIndex >= 0) {
			this.onOptionChange(searchIndex);
		}
		// if no matches, clear the timeout and search string
		else {
			window.clearTimeout(this.searchTimeout);
			this.searchString = '';
		}
	};

	Select.prototype.onOptionChange = function (index) {
		// update state
		this.activeIndex = index;

		// update aria-activedescendant
		this.comboEl.setAttribute(
			'aria-activedescendant',
			`${this.idBase}-${index}`
		);

		// update active option styles
		const options = this.el.querySelectorAll('[role=option]');
		[...options].forEach((optionEl) => {
			optionEl.classList.remove('is-option-current');
		});
		options[index].classList.add('is-option-current');

		// ensure the new option is in view
		if (isScrollable(this.listboxEl)) {
			maintainScrollVisibility(options[index], this.listboxEl);
		}

		// ensure the new option is visible on screen
		// ensure the new option is in view
		if (!isElementInView(options[index])) {
			options[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	};

	Select.prototype.onOptionClick = function (index) {
		this.onOptionChange(index);
		this.selectOption(index);
		this.updateMenuState(false);
	};

	Select.prototype.onOptionMouseDown = function () {
		// Clicking an option will cause a blur event,
		// but we don't want to perform the default keyboard blur action
		this.ignoreBlur = true;
	};

	Select.prototype.selectOption = function (index) {
		// update state
		this.activeIndex = index;

		// update displayed value
		const selected = this.options[index].innerText;
		this.comboEl.innerHTML = selected;

		// update aria-selected
		const options = this.el.querySelectorAll('[role=option]');
		[...options].forEach((optionEl) => {
			optionEl.setAttribute('aria-selected', 'false');
		});
		options[index].setAttribute('aria-selected', 'true');

		// update <select>
		this.selector.value = this.selector.querySelectorAll('option')[index].value;
	};

	Select.prototype.updateMenuState = function (open, callFocus = true) {
		if (this.open === open) {
			return;
		}

		// update state
		this.open = open;

		// update aria-expanded and styles
		this.comboEl.setAttribute('aria-expanded', `${open}`);
		open
			? this.el.classList.add('is-open')
			: this.el.classList.remove('is-open');

		// update activedescendant
		const activeID = open ? `${this.idBase}-${this.activeIndex}` : '';
		this.comboEl.setAttribute('aria-activedescendant', activeID);

		if (activeID === '' && !isElementInView(this.comboEl)) {
			this.comboEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}

		// move focus back to the selector, if needed
		callFocus && this.comboEl.focus();
	};

	// init select
	document.querySelectorAll('.js-combobox-selector').forEach((el) => {
		let options = [];

		el.querySelectorAll('option').forEach((option) => {
			options.push(option);
		});

		new Select(el, options);
	});
};

const initFiltering = () => {
	const filters = document.querySelectorAll(`.js-filter select`);
	if (filters.length > 0) {
		const itemsToFilter = document.querySelectorAll(`.js-filter-item`);
		const itemsToFilterContainer = itemsToFilter[0].parentNode;
		const transitionTime = 100;

		const filterItems = () => {
			let selector = '.js-filter-item';

			filters.forEach((filter) => {
				if (filter.value != 'all') {
					selector += `[data-${filter.id.replace('-select', '')}*="${
						filter.value
					}"]`;
				}
			});

			itemsToFilter.forEach((item) => {
				item.classList.add('is-hidden');
			});

			document.querySelectorAll(selector).forEach((item) => {
				item.classList.remove('is-hidden');
			});

			setTimeout(() => {
				itemsToFilterContainer.classList.remove('is-filtering');
			}, transitionTime);
		};

		// update on option select
		on('body', 'click', '.js-filter [data-value]', (e) => {
			itemsToFilterContainer.classList.add('is-filtering');
			setTimeout(() => {
				filterItems();
			}, transitionTime);
		});

		// on native select change
		on('body', 'change','.js-filter select', e => {
			itemsToFilterContainer.classList.add('is-filtering');
			setTimeout(() => {
				filterItems();
			}, transitionTime);
		});
	}
};

const initRecipeCards = () => {
	const closeCard = (card) => {
		const cardFront = card.querySelector('.js-recipe-card-front');
		const cardBack = card.querySelector('.js-recipe-card-back');
		card.classList.remove('is-open');
		cardFront.setAttribute('aria-hidden', false);
		cardBack.setAttribute('aria-hidden', true);
	};

	const openCard = (card) => {
		const cardFront = card.querySelector('.js-recipe-card-front');
		const cardBack = card.querySelector('.js-recipe-card-back');
		card.classList.add('is-open');
		cardFront.setAttribute('aria-hidden', true);
		cardBack.setAttribute('aria-hidden', false);
	};

	on('body', 'click', '.js-recipe-card', (e) => {
		const card = e.target.closest('.js-recipe-card');
		card.classList.contains('is-open') ? closeCard(card) : openCard(card);
	});

	// close card on outside click
	// document.addEventListener('click', e => {
	// 	const clickInActiveCard = e.target.closest('.js-recipe-card.is-open');
	// 	const activeCard = document.querySelector('.js-recipe-card.is-open');

	// 	if(!clickInActiveCard && activeCard) {
	// 		closeCard(activeCard);
	// 	}
	// })
};

const initAccordions = () => {

	const toggleAccordion = (accordion, shouldCloseAllOthers = true) => {
		let accordionContent = accordion.querySelector('.comp-accordion__content');

		// If shouldCloseAllOthers is true, close all other accordions first
		if (shouldCloseAllOthers) {
			const allAccordions = document.querySelectorAll('.comp-accordion');
			allAccordions.forEach(otherAccordion => {
				if (otherAccordion !== accordion) {
					// Close the other accordion
					let otherAccordionContent = otherAccordion.querySelector('.comp-accordion__content');
					otherAccordion.classList.remove('is-expanded');
					otherAccordion.setAttribute('aria-expanded', false);
					otherAccordionContent.setAttribute('aria-hidden', true);
				}
			});
		}

		accordion.classList.toggle('is-expanded');

		if (accordion.classList.contains('is-expanded')) {
			accordion.setAttribute('aria-expanded', true);
			accordionContent.setAttribute('aria-hidden', false);
		} else {
			accordion.setAttribute('aria-expanded', false);
			accordionContent.setAttribute('aria-hidden', true);
		}
	}

	on('button', 'click', '.js-toggle-accordion', e => {
		toggleAccordion(e.target.closest('.comp-accordion'));
	});

	// Automatically open the first accordion on the page
	let firstAccordion = document.querySelector('.js-toggle-accordion');
	if(firstAccordion !== null) {
		firstAccordion.click();
	}

};

const initModals = () => {
	const triggerModal = $('[data-action="modal-toggle"]');

	triggerModal.click(function () {
		// (de)activate modal
		html.toggleClass('modal_active');
		let _this = $(this);
		let modal = $(`#${_this.attr('data-modal')}`);

		modal.toggleClass('active');

		if (html.hasClass('modal_active')) {
			// if modal is active, disable scroll
			scrollDisable();
		} else {
			// else, enable scroll
			scrollEnable();
		}
	});
};

// execute global functions
initItemQuantity();
initPageTransition();
initPageAnimation();
initCart();
initProduct();
initCollection();
initAccordions();
initComboBox();
initFiltering();
initRecipeCards();
initModals();

// execute page specific functions
switch (root.id) {
	case 'template-frontpage':
		// initFrontpage();
		break;

	case 'template-account':
		initAccount();
		break;
}

// make visible .avoid-style-flash elements
setTimeout(() => {
	document.querySelectorAll('.avoid-style-flash').forEach((el) => {
		el.style.visibility = 'visible';
	});
}, 400);
